<template>
  <div v-if="item[itemKey].percent" class="table-cell passthrough">
    <PassthroughCell :value="item[itemKey].value" :percent="item[itemKey].percent">
      <template #after-value>
        <slot name="after-value" :item="item" />
      </template>
    </PassthroughCell>
  </div>
  <div v-else class="table-cell value new-body-text" :class="{ arrow: item[itemKey].showArrow }">
    {{ typeof item[itemKey].value === 'string'
      ? item[itemKey].value
      : formatValue(item[itemKey].value)
    }}
    <slot name="after-value" :item="item" />
    <v-icon
      v-if="item[itemKey].showArrow"
      class="pass-through-arrow"
      size="10px"
      icon="$arrow-right"
    />
  </div>
</template>

<script setup>
import PassthroughCell from '@/components/insights/ProcessInsights/DemographicSurveyReport/tables/PassthroughCell.vue';
import { formatValue } from '@/components/insights/helpers';

defineProps({
  item: {
    type: Object,
    required: true,
  },
  itemKey: {
    type: String,
    required: true,
  },
});

</script>

<style lang="less" scoped>
.table-cell {
  max-height: 33px;

  :deep(.percentage) {
    font-size: 12px
  }

  &:not(:first-child):not(:last-child) {
    margin-right: 12px;
  }

  &:not(.passthrough) {
    padding: 8px;
  }

  &.value {
    padding: 8px;
    color: @text-darkest;
    border-bottom: 1px solid @stroke-default;

    &.label {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &.arrow {
    position: relative;
  }

  .pass-through-arrow {
    position: absolute;
    right: -2px;
    bottom: -5.5px;
    color: @grey-500;
    z-index: 2;
  }
}
</style>
